module.exports = __webpack_public_path__ + "img/3_2.e7f73c68.png";